import classNames from "classnames";
import { Color } from "PFCore/types";

import css from "./divider.module.scss";

type DividerProps = {
  className?: string;
  type?: "horizontal" | "vertical";
  color?: Color;
  thickness?: number;
};

export const Divider = ({
  className,
  type = "horizontal",
  color = "paletteNeutral0",
  thickness = 1
}: DividerProps) => {
  const colorStyle = color
    ? {
        borderColor: `var(--${color})`
      }
    : {};

  const sizeStyle = thickness
    ? { [type === "horizontal" ? "borderBottomWidth" : "borderRightWidth"]: `${thickness}px` }
    : {};

  const style = {
    ...colorStyle,
    ...sizeStyle
  };

  return (
    <div
      className={classNames(
        css.divider,
        {
          [css.horizontal]: type === "horizontal",
          [css.vertical]: type === "vertical"
        },
        className
      )}
      style={style}
    />
  );
};
